import {
  CustomViewComponent,
  CustomViewPageCategory,
  CustomViewPages,
  CustomViewTemplateIdType,
  CustomViewTypeIdType,
} from '@agilelab/plugin-wb-platform';
import preview from './preview/builder_descriptor_component_preview/builder_descriptor_component_preview.png';
import thumbnail from './preview/builder_descriptor_component_preview/builder_descriptor_component_preview_thumbnail.png';

CustomViewPages.register({
  id: 'builder_descriptor_component_preview',
  meta: {
    label: 'Descriptor Component Preview',
    category: CustomViewPageCategory.BUILDER,
    typeId: {
      type: CustomViewTypeIdType.COMPONENT_TYPE,
    },
    templateId: {
      type: CustomViewTemplateIdType.COMPONENT_TYPE,
    },
    preview: {
      thumbnail: { src: thumbnail },
      items: [{ src: preview }],
    },
  },
  data: (
    <>
      <CustomViewComponent type="card" title="About">
        <CustomViewComponent type="container">
          <CustomViewComponent
            type="string"
            label="Name"
            path="component.name"
            colSpan="2"
          />
          <CustomViewComponent
            type="string"
            label="Kind"
            path="component.kind"
            colSpan="2"
          />
          <CustomViewComponent
            type="string"
            label="Version"
            path="component.version"
            colSpan="2"
          />
          <CustomViewComponent
            type="string"
            label="Domain"
            path="component.domain"
            colSpan="2"
          />
          <CustomViewComponent
            type="string"
            label="Owner"
            path="component.projectOwner"
            colSpan="2"
          />
          <CustomViewComponent
            type="string"
            label="Use Case Template ID"
            path="component.useCaseTemplateId"
            colSpan="2"
          />
          <CustomViewComponent
            type="string"
            label="Infrastructure Template ID"
            path="component.infrastructureTemplateId"
            colSpan="2"
          />
          <CustomViewComponent
            type="string"
            label="Environment"
            path="component.environment"
            colSpan="2"
          />
        </CustomViewComponent>
      </CustomViewComponent>
    </>
  ),
});
